import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export interface IWFNXCardBodyProps {
  className?: string;
}

export class WFNXCardBody extends React.Component<React.PropsWithChildren<IWFNXCardBodyProps>, any> {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { className } = this.props;

    return (
      <div className={classNames('wfnx-small-card-body', className)}>
        {this.props.children}
      </div>
    );
  }
}
